module.exports = __webpack_public_path__ + "media/recipes/77-2dda6f64.png";